/** A value the buyer pinned, standing in for the engine's. */
export const OVERRIDDEN_VALUE_CLASS = 'font-semibold text-blue-700';

/** The engine value an override replaced, kept in view and struck through. */
export const SUPERSEDED_VALUE_CLASS = 'text-muted-foreground line-through';
